'use strict';

var utils = require('./../utils');


module.exports = function transformData(data, headers, fns) {
  
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/core/transformData.js
// module id = 674
// module chunks = 0